export default "__VITE_ASSET__CQr4uy95__"